import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const AirTankWidget = ({
  width = 126,
  height = 216,
  color,
  iconColor,
  dry,
  ...rest
}: {
  width: number;
  height: number;
  color: string;
  iconColor?: string;
  dry?: boolean;
  [key: string]: unknown;
}) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };
  const currentColor = color ?? token.colorBgContainer;
  const currentIconColor = iconColor ?? token.colorPrimary;

  return (
    <svg width={width} height={height} viewBox="0 0 126 216" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M5 113H3C1.89543 113 1 112.105 1 111L1 103C1 101.895 1.89543 101 3 101H5L5 113Z"
        fill={token.colorBorder}
      />
      <g filter="url(#filter0_ddd_24621_1836)">
        <path
          d="M121 34H63H5C5 17.4315 30.9675 4 63 4C95.0325 4 121 17.4315 121 34Z"
          fill={currentColor}
          stroke={currentColor}
        />
        <rect width="116" height="40" transform="translate(5 34)" fill={currentColor} stroke={currentColor} />
        {dry ? (
          <>
            <path
              d="M103.225 56.0339C103.225 57.5258 102.632 58.9565 101.578 60.0114C100.523 61.0663 99.0919 61.6589 97.6001 61.6589C96.1083 61.6589 94.6775 61.0663 93.6226 60.0114C92.5677 58.9565 91.9751 57.5258 91.9751 56.0339C91.9751 50.9714 97.6001 47.0339 97.6001 47.0339C97.6001 47.0339 103.225 50.9714 103.225 56.0339Z"
              fill={currentIconColor}
              opacity={currentIconColor ? '0.2' : 1}
            />
            <path
              d="M92.3915 48.3432C92.3421 48.2876 92.2821 48.2422 92.2151 48.2099C92.148 48.1776 92.0752 48.1588 92.0009 48.1548C91.9266 48.1508 91.8522 48.1616 91.7821 48.1866C91.712 48.2116 91.6475 48.2502 91.5924 48.3003C91.5373 48.3503 91.4927 48.4108 91.4612 48.4782C91.4296 48.5457 91.4118 48.6187 91.4087 48.693C91.4056 48.7674 91.4173 48.8417 91.4431 48.9115C91.4689 48.9813 91.5083 49.0453 91.559 49.0998L93.1509 50.8513C91.9977 52.5887 91.4127 54.3311 91.4127 56.034C91.4128 57.2492 91.7707 58.4375 92.4418 59.4506C93.1129 60.4638 94.0674 61.2568 95.1863 61.7309C96.3053 62.205 97.539 62.3391 98.7337 62.1165C99.9283 61.8939 101.031 61.3244 101.904 60.4792L102.809 61.4748C102.858 61.5305 102.918 61.5758 102.985 61.6082C103.052 61.6405 103.125 61.6592 103.2 61.6632C103.274 61.6672 103.348 61.6564 103.418 61.6314C103.489 61.6065 103.553 61.5679 103.608 61.5178C103.663 61.4677 103.708 61.4072 103.739 61.3398C103.771 61.2724 103.789 61.1994 103.792 61.125C103.795 61.0506 103.783 60.9764 103.757 60.9066C103.732 60.8367 103.692 60.7727 103.641 60.7182L92.3915 48.3432ZM97.6002 61.0965C96.258 61.095 94.9712 60.5612 94.0222 59.6121C93.0731 58.663 92.5392 57.3762 92.5377 56.034C92.5377 54.6327 93.0074 53.1814 93.9341 51.7126L101.146 59.6453C100.201 60.5759 98.9269 61.0972 97.6002 61.0965ZM94.9284 49.4605C94.8204 49.3576 94.7577 49.216 94.7542 49.0668C94.7506 48.9177 94.8064 48.7732 94.9094 48.6653C95.6338 47.8977 96.4264 47.1976 97.2775 46.5735C97.3721 46.5072 97.4848 46.4717 97.6002 46.4717C97.7157 46.4717 97.8284 46.5072 97.923 46.5735C98.1627 46.7408 103.788 50.7395 103.788 56.034C103.788 56.5899 103.714 57.1433 103.566 57.6793C103.534 57.7981 103.463 57.9029 103.365 57.9775C103.267 58.0522 103.147 58.0927 103.024 58.0928C102.973 58.0932 102.923 58.0866 102.874 58.0731C102.73 58.0335 102.608 57.9384 102.534 57.8088C102.46 57.6792 102.441 57.5257 102.481 57.3819C102.601 56.9428 102.662 56.4894 102.663 56.034C102.663 52.0093 98.7618 48.6512 97.6002 47.7371C96.9356 48.2596 96.3091 48.829 95.7257 49.4408C95.6747 49.4946 95.6137 49.5379 95.5459 49.568C95.4782 49.5981 95.4052 49.6146 95.3311 49.6164C95.257 49.6182 95.1833 49.6054 95.1142 49.5787C95.0451 49.5519 94.9819 49.5117 94.9284 49.4605Z"
              fill={currentIconColor}
            />
          </>
        ) : (
          <>
            <path
              d="M102.625 56.0339C102.625 57.5258 102.032 58.9565 100.977 60.0114C99.9226 61.0663 98.4918 61.6589 97 61.6589C95.5082 61.6589 94.0774 61.0663 93.0225 60.0114C91.9676 58.9565 91.375 57.5258 91.375 56.0339C91.375 50.9714 97 47.0339 97 47.0339C97 47.0339 102.625 50.9714 102.625 56.0339Z"
              fill={currentIconColor}
              opacity={currentIconColor ? '0.2' : 1}
            />
            <path
              d="M100.234 49.2664C99.3659 48.2634 98.3884 47.3602 97.3199 46.5735C97.2253 46.5072 97.1127 46.4717 96.9972 46.4717C96.8817 46.4717 96.769 46.5072 96.6745 46.5735C95.608 47.3605 94.6324 48.2637 93.7656 49.2664C91.8327 51.4862 90.8125 53.8262 90.8125 56.034C90.8125 57.675 91.4644 59.2489 92.6248 60.4092C93.7852 61.5696 95.359 62.2215 97 62.2215C98.641 62.2215 100.215 61.5696 101.375 60.4092C102.536 59.2489 103.188 57.675 103.188 56.034C103.188 53.8262 102.167 51.4862 100.234 49.2664ZM97 61.0965C95.6578 61.095 94.371 60.5612 93.4219 59.6121C92.4728 58.663 91.939 57.3762 91.9375 56.034C91.9375 52.01 95.8377 48.6512 97 47.7371C98.1623 48.6512 102.062 52.0086 102.062 56.034C102.061 57.3762 101.527 58.663 100.578 59.6121C99.629 60.5612 98.3422 61.095 97 61.0965Z"
              fill={currentIconColor}
            />
          </>
        )}
        <rect width="116" height="85" transform="translate(5 74)" fill={currentColor} stroke={currentColor} />
        <path
          d="M121 159H5C5 166.242 10.0265 172.881 18.3846 178.046V210H32.5128L38.9073 186.12C46.2451 187.844 54.4042 188.805 63 188.805C71.5958 188.805 79.7549 187.844 87.0927 186.12L93.4872 210H107.615V178.046C115.974 172.881 121 166.242 121 159Z"
          fill={currentColor}
          stroke={currentColor}
        />
      </g>
      <path
        d="M121 101H123C124.105 101 125 101.895 125 103V111C125 112.105 124.105 113 123 113H121V101Z"
        fill={token.colorBorder}
      />
      <defs>
        <filter
          id="filter0_ddd_24621_1836"
          x="0"
          y="0"
          width="126"
          height="216"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_24621_1836" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_dropShadow_24621_1836" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_24621_1836" result="effect2_dropShadow_24621_1836" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_24621_1836" result="effect3_dropShadow_24621_1836" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_24621_1836" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default AirTankWidget;
